import { useState, useRef, useEffect } from 'react';
import { Widget } from '@/shared/Constants';
export const useIsTrustBoxPriceDetailsVisible = () => {
  const [isVisible, setIsVisible] = useState(true);
  const sidebarRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, {
      threshold: 0,
      rootMargin: `-${Widget.HORIZONTAL_STYLE_NAVBAR_DESKTOP_HEIGHT}px`
    });
    if (sidebarRef.current) {
      observer.observe(sidebarRef.current);
    }
    const previousRef = sidebarRef.current;
    return () => {
      if (previousRef) {
        observer.unobserve(previousRef);
      }
    };
  }, []);
  return {
    sidebarRef,
    isVisible
  };
};